import { HttpClient } from '@angular/common/http';
import {
  Component,
  Inject,
  OnInit,
  Optional,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { LoginScreenDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/login-screen-dialog/login-screen-dialog.component';
import { VisitorTokenExpiredDialogComponentComponent } from 'src/app/common/modules/dialog-pop-ups/components/visitor-token-expired-dialog-component/visitor-token-expired-dialog-component.component';
import { ScreenType } from 'src/app/enums/ScreenType';
import { Visitor } from 'src/app/models/visitor';
import { AumyeSecurityPassService } from 'src/app/services/aumye-security-pass.service';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { environment } from 'src/app/environments/environments';
@Component({
  selector: 'app-host-approval',
  templateUrl: './host-approval.component.html',
  styleUrls: ['./host-approval.component.scss'],
})
export class HostApprovalComponent implements OnInit {
  visitorId: string;
  visitorData: Visitor;
  isDisable = false;
  isFetched = false;
  isFetchingRequest = false;
  @ViewChild('VisitorApprovalDialog', { static: true })
  visitorApprovalDialog: TemplateRef<any>;
  @ViewChild('InProgresslDialog', { static: true })
  inProgresslDialog: TemplateRef<any>;
  @ViewChild('FailedErrorDialog', { static: true })
  failedErrorDialog: TemplateRef<any>;
  baseServerURL = environment.apiUrl;
  constructor(
    private activeRoute: ActivatedRoute,
    private formbuilder: FormBuilder,
    private dialog: MatDialog,
    private httpclient: HttpClient,
    private screen: AumyeResponsiveScreenService,
    @Optional() @Inject(MAT_DIALOG_DATA) public visitorDetails: Visitor
  ) {
    this.activeRoute.queryParams.subscribe((params) => {
      this.visitorId = params['id'];
    });
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }
  screenSize: ScreenType;
  visitorGateEntryHostApproval = this.formbuilder.group({
    visitorID: [],
    hostUserId: [],
    fullName: ['', Validators.required],
    lastName: ['', Validators.required],
    email: ['', [Validators.email]],
    phoneNumber: ['', Validators.required],
    visitorAddress: [],
    gender: [],
    purpose: ['', Validators.required],
    carRegistration: [],
    identityID: [''],
    hostName: ['', Validators.required],
    profilePicture: [''],
    securityStatus: [''],
    qrCode: [''],
    visitDateTime: [''],
    visitorCommentsTimeline: [''],
    visitorTimline: [''],
  });
  isApprovePopUp = false;

  ngOnInit() {
    if (!this.visitorId) {
      this.visitorId = this.visitorDetails.visitorID;
      this.isApprovePopUp = true;
      this.setFormData(this.visitorDetails);
      this.isFetched = true;
    } else {
      this.isFetchingRequest = true;
      let baseServerURL =
        this.baseServerURL + 'GetVisitorSecurityPass?id=' + this.visitorId;
      this.httpclient.get(baseServerURL).subscribe({
        next: (res: any) => {
          this.visitorData = res;
          this.isFetched = true;
          this.setFormData(res);
        },
        error: (error: any) => {
          // Error callback
          this.dialog.open(VisitorTokenExpiredDialogComponentComponent, {
            disableClose: true,
            backdropClass: 'session-backdrop',
          });
        },
      });
    }
  }
  setFormData(val: Visitor) {
    this.visitorGateEntryHostApproval.controls.fullName.setValue(
      (val.firstName + ' ' + val.lastName).toUpperCase()
    );
    this.visitorGateEntryHostApproval.controls.email.setValue(val.email);
    this.visitorGateEntryHostApproval.controls.phoneNumber.setValue(
      val.phoneNumber
    );
    this.visitorGateEntryHostApproval.controls.visitorAddress.setValue(
      val.visitorAddress
    );
    this.visitorGateEntryHostApproval.controls.hostUserId.setValue(
      val.hostUserId
    );
    this.visitorGateEntryHostApproval.controls.hostName.setValue(val.hostName);
    this.visitorGateEntryHostApproval.controls.purpose.setValue(val.purpose);
    this.visitorGateEntryHostApproval.controls.profilePicture.setValue(
      val.profilePicture
    );
    this.visitorGateEntryHostApproval.controls.carRegistration.setValue(
      val.carRegistration
    );
    this.visitorGateEntryHostApproval.controls.visitorCommentsTimeline.setValue(
      val.visitorCommentsTimeline
    );
    this.visitorGateEntryHostApproval.controls.visitorTimline.setValue(
      val.visitorTimline
    );
    this.isFetchingRequest = false;
  }
  onClickButton(key: -1 | 1) {
    this.dialog.open(this.inProgresslDialog, {
      disableClose: true,
    });
    this.isDisable = true;
    this.visitorGateEntryHostApproval.disable();
    let data = {
      visitorHost: this.visitorGateEntryHostApproval.controls.hostName.value,
      visitorHostId:
        this.visitorGateEntryHostApproval.controls.hostUserId.value,
      visitorProfile:
        this.visitorGateEntryHostApproval.controls.profilePicture.value,
      visitorEmail: this.visitorGateEntryHostApproval.controls.email.value,
      visitorName: this.visitorGateEntryHostApproval.controls.fullName.value,
      visitorId: this.visitorId,
      orgID: this.isApprovePopUp
        ? this.visitorDetails.orgID
        : this.visitorData.orgID,
      Phonenumber: this.visitorGateEntryHostApproval.controls.phoneNumber.value,
      status: key,
      VisitorCommentsTimeline:
        this.visitorGateEntryHostApproval.controls.visitorCommentsTimeline
          .value,
      visitorTimline:
        this.visitorGateEntryHostApproval.controls.visitorTimline.value,
    };
    let baseServerURL = this.baseServerURL + 'HostVerification';
    this.httpclient
      .post(baseServerURL, data, {
        responseType: 'text',
      })
      .subscribe({
        next: (res: any) => {
          this.dialog.closeAll();
          if (!this.isApprovePopUp) {
            this.dialog.open(this.visitorApprovalDialog, {
              disableClose: false,
            });
            setTimeout(() => {
              window.close();
            }, 2000);
          }
        },
        error: (error: any) => {
          this.dialog.closeAll();
          this.dialog.open(this.failedErrorDialog, {
            disableClose: true,
          });
        },
      });
  }
  openLoginPopUp(val: Visitor) {
    let isUserLoggedIn = localStorage.getItem('UserId');
    let isUser = localStorage.getItem('role') === 'user';
    if (
      (isUserLoggedIn && !isUser) ||
      (isUser && val.hostUserId.toLowerCase() === isUserLoggedIn.toLowerCase())
    ) {
      this.isFetched = true;
    } else {
      const dialogRef = this.dialog.open(LoginScreenDialogComponent, {
        disableClose: true,
        data: this.visitorData,
      });
      dialogRef.afterClosed().subscribe((res) => {
        if (res) {
          this.isFetched = false;
        }
      });
    }
  }
  refreshWindow() {
    window.location.reload();
  }
  ScreenType = ScreenType;
}
